var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconHuman(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:#72383D;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-32 -8)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 20,
    height: 20,
    transform: "translate(32 8)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-29.599 -380.428)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M74.789,392.4h-6.38v-.008a3.428,3.428,0,0,0-3.525,3.59l.5,3.688c.4,1.967,1.583,3.525,3.536,3.525h5.364c1.944,0,3.133-1.619,3.525-3.573l.5-3.705C78.565,393.992,76.733,392.4,74.789,392.4Z",
    transform: "translate(0 4.339)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M73.536,392.014a3.584,3.584,0,1,1-3.584-3.586A3.581,3.581,0,0,1,73.536,392.014Z",
    transform: "translate(1.648 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHuman);
export default __webpack_public_path__ + "static/media/icon_human.de4bccc1ce4f17ebb80c8d1c8fedd3d0.svg";
export { ForwardRef as ReactComponent };